import React, {useEffect, useState} from "react";
import {Platform} from "../layouts/Platform";
import {Box, Button, Stack, Typography, useTheme} from "@mui/material";
import {useLocalStorage} from "../functions/customHooks/useLocalStorage";
import {useUserStore} from "../store/userStore";
import {useTestStore} from "../store/testStore";
import {useDocument} from "react-firebase-hooks/firestore";
import {firestore} from "../firebase/clientApp";
import {CURRENT_SESSION_ID} from "../config";
import {Link} from "react-router-dom";

export const Webinar = () => {
  const [watched, setWatched] = useLocalStorage('watched', false)
  const {user} = useUserStore()
  const {test} = useTestStore()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [success, setSuccess] = useState(true)

  const [testOpened, loadingTestOpened, errorTestOpened] =
    useDocument(firestore.doc(`sessions/${CURRENT_SESSION_ID}/webinars/${user?.slotWebinar || '-'}`))

  useEffect(() => {
    if (user && test.length > 0) {
      let t = test.filter((t) => t.session_id === '0723').filter(t => t.test_passed === true)
      if (t.length > 0) {
        setSuccess(true)
      }
    }
  }, [test, user])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme()

  return (
    <Platform>
      {/*<Modal open={!watched} onClose={() => setWatched(true)}>
                <Container maxWidth={'md'} sx={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    outline: 'none'
                }}>
                    <Card sx={{width: '100%', position: 'relative'}}>
                        <IconButton sx={{position: 'absolute', top: '1rem', right: '1rem'}} variant={'contained'}
                                    onClick={() => setWatched(true)}>
                            <Close/>
                        </IconButton>
                        <CardContent>
                            <Typography variant={'h6'} sx={{
                                textAlign: 'center',
                                fontFamily: 'Dacia Block Extended',
                                color: theme.palette.primary.main
                            }}>
                                BENVENUTO
                            </Typography>
                            <Typography textAlign={'center'} sx={{pb: 2}}>
                                Rudy Bandiera introduce il programma Dacia Empowerment
                            </Typography>
                            <Box sx={{width: '100%'}}>
                                <div style={{padding: "56.25% 0 0 0", position: "relative"}}>
                                    <iframe
                                        src="https://player.vimeo.com/video/838295220?h=7a6fd700fe&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                        frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
                                        style={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            width: "100%",
                                            height: "100%"
                                        }}
                                        title="BENVENUTO - Rudy Bandiera introduce il programma Dacia Empowerment"></iframe>
                                </div>
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            </Modal>*/}
      {
        testOpened?.data()?.isOpen ?
          <Stack alignItems={'center'}>
            {user?.slotWebinar ? <Typography sx={{textAlign: 'center', pt: 1, pb: 3}} variant={'h6'}>
                Hai partecipato al webinar del
                giorno {user?.slotWebinar ? testOpened?.data()?.label : ''}
              </Typography>
              : <Typography sx={{textAlign: 'center', pt: 1, pb: 3}} variant={'h6'}>
                Non ti risulta assegnato nessuno slot webinar
              </Typography>}
            <Typography sx={{textAlign: 'center', pt: 1, pb: 3}} variant={'h6'}>
              Per qualsiasi approfondimento, puoi rivedere le registrazioni dei webinar all’interno della
              sezione Contenuti.
            </Typography>
            <Button component={Link} to={"contenuti"} variant={"contained"}>
              Vai ai contenuti
            </Button>
          </Stack>
          : <>
            {user?.slotWebinar ? <Typography sx={{textAlign: 'center', pt: 1, pb: 3}} variant={'h6'}>
                Il webinar inizierà il giorno {user?.slotWebinar ? testOpened?.data()?.label : ''}
              </Typography>
              : <Typography sx={{textAlign: 'center', pt: 1, pb: 3}} variant={'h6'}>
                Non ti risulta assegnato nessuno slot webinar
              </Typography>}
            {/*<Box sx={{textAlign: 'center', pb: 3}}>
                            <Button variant={'outlined'} startIcon={<CalendarToday/>} onClick={handleClick} size={'small'}>
                                SALVA LA DATA IN AGENDA
                            </Button>
                        </Box>}
                        {user?.slotWebinar && <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                        >
                            <MenuItem component={'a'}
                                      href={`https://calndr.link/e/${webinarMap[user.slotWebinar]["calndrId"]}?s=google`}
                                      target={'_blank'}>
                                <ListItemIcon>
                                    <Google/>
                                </ListItemIcon>
                                <ListItemText>Google</ListItemText>
                            </MenuItem>
                            <MenuItem component={'a'}
                                      href={`https://calndr.link/e/${webinarMap[user.slotWebinar]["calndrId"]}?s=outlook`}
                                      target={'_blank'}>
                                <ListItemIcon>
                                    <Icon>
                                        <img style={{width: '100%', objectFit: 'cover'}}
                                             src={require('../assets/images/outlook.png')}/>
                                    </Icon>
                                </ListItemIcon>
                                <ListItemText>Outlook</ListItemText>
                            </MenuItem>
                            <MenuItem component={'a'}
                                      href={`https://calndr.link/e/${webinarMap[user.slotWebinar]["calndrId"]}?s=apple`}
                                      target={'_blank'}>
                                <ListItemIcon>
                                    <Apple/>
                                </ListItemIcon>
                                <ListItemText>Apple</ListItemText>
                            </MenuItem>
                        </Menu>*/}
            <Box sx={{textAlign: 'center'}}>
              <Button disabled={(!user["zoomUrl"] || user["zoomUrl"] === "") || !success}
                      variant={'contained'}
                      href={user["zoomUrl"]} target={'_blank'} size={'large'}>
                partecipa
              </Button>
            </Box>
          </>
      }

      {/*!success && <Box>
                <Typography textAlign={'center'} sx={{pt: 3}} fontSize={18} fontWeight={'bold'}>
                    Per accedere al webinar è necessario aver superato il test della sessione di Luglio
                </Typography>
                <Typography textAlign={'center'} sx={{py: 1}}>
                    Puoi visionare il webinar della scorsa sessione qui sotto
                </Typography>
                <Box sx={{width: 'min(35rem, 100%)', margin: 'auto'}}>
                    <div style={{padding: "56.25% 0 0 0", position: "relative"}}>
                        <iframe
                            src={'https://player.vimeo.com/video/842458284?h=79423cb817&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'}
                            frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
                            style={{position: "absolute", top: "0", left: "0", width: "100%", height: "100%"}}
                            title="BENVENUTO - Rudy Bandiera introduce il programma Dacia Empowerment"></iframe>
                    </div>
                </Box>
            </Box>*/}
      {/*<Typography textAlign={'center'} fontSize={24} fontFamily={'Dacia Block Extended'}>
                In aggiornamento...
            </Typography>*/}
    </Platform>
  )
}

// @deprecated
export const webinarMap = {
  /** OTTOBRE 25 */

  "13lun1012": {
    "id": "13lun1012",
    "isOpen": false,
    "label": "Lunedì 13 ottobre (ore 10:00 - 12:00)",
    "plenaryMeetingID": "83000485483",
    "position": 2
  },
  "13lun1416": {
    "id": "13lun1416",
    "isOpen": false,
    "label": "Lunedì 13 ottobre (ore 14:30 - 16:30)",
    "plenaryMeetingID": "85838332504",
    "position": 3
  },
  "20lun1012": {
    "id": "20lun1012",
    "isOpen": false,
    "label": "Lunedì 20 ottobre (ore 10:00 - 12:00)",
    "plenaryMeetingID": "85828682647",
    "position": 4
  },
  "20lun1416": {
    "id": "20lun1416",
    "isOpen": false,
    "label": "Lunedì 20 ottobre (ore 14:30 - 16:30)",
    "plenaryMeetingID": "87292710732",
    "position": 5
  },
  "21mar1012": {
    "id": "21mar1012",
    "isOpen": false,
    "label": "Martedì 21 ottobre (ore 10:00 - 12:00)",
    "plenaryMeetingID": "89184197307",
    "position": 6
  },
  "21mar1416": {
    "id": "21mar1416",
    "isOpen": false,
    "label": "Martedì 21 ottobre (ore 14:30 - 16:30)",
    "plenaryMeetingID": "84167727291",
    "position": 7
  },
  "7mar1012": {
    "id": "7mar1012",
    "isOpen": false,
    "label": "Martedì 7 ottobre (ore 10:00 - 12:00)",
    "plenaryMeetingID": "81984434020",
    "position": 0
  },
  "7mar1416": {
    "id": "7mar1416",
    "isOpen": false,
    "label": "Martedì 7 ottobre (ore 14:30 - 16:30)",
    "plenaryMeetingID": "89119118527",
    "position": 1
  },

  /** MAGGIO 25 */

  "12lun1012": {
    "label": "Lunedì 12 Maggio (ore 10:00 - 12:00)",
    "position": 0,
    "calndrId": ""
  },
  "12lun1416": {
    "label": "Lunedì 12 Maggio (ore 14:30 - 16:30)",
    "position": 1,
    "calndrId": ""
  },
  "13mar1012": {
    "label": "Martedì 13 Maggio (ore 10:00 - 12:00)",
    "position": 2
  },
  "13mar1416": {
    "label": "Martedì 13 Maggio (ore 14:30 - 16:30)",
    "position": 3,
    "calndrId": ""
  },
  "26lun1012": {
    "label": "Lunedì 26 Maggio (ore 10:00 - 12:00)",
    "position": 4,
    "calndrId": ""
  },
  "26lun1416": {
    "label": "Lunedì 26 Maggio (ore 14:30 - 16:30)",
    "position": 5,
    "calndrId": ""
  },
  "27mar1012": {
    "label": "Martedì 27 Maggio (ore 10:00 - 12:00)",
    "position": 6,
    "calndrId": ""
  },
  "27mar1416": {
    "label": "Martedì 27 Maggio (ore 14:30 - 16:30)",
    "position": 7,
    "calndrId": ""
  },

  /** OTTOBRE 24 */

  "14lun1012": {
    "label": "Lunedì 14 Ottobre (ore 10:00 - 12:00)",
    "position": 8,
    "calndrId": ""
  },
  "14lun1416": {
    "label": "Lunedì 14 Ottobre (ore 14:30 - 16:30)",
    "position": 9,
    "calndrId": ""
  },
  "15mar1012": {
    "label": "Martedì 15 Ottobre (ore 10:00 - 12:00)",
    "position": 10
  },
  "15mar1416": {
    "label": "Martedì 15 Ottobre (ore 14:30 - 16:30)",
    "position": 11,
    "calndrId": ""
  },
  "21lun1012": {
    "label": "Lunedì 21 Ottobre (ore 10:00 - 12:00)",
    "position": 12,
    "calndrId": ""
  },
  "21lun1416": {
    "label": "Lunedì 21 Ottobre (ore 14:30 - 16:30)",
    "position": 13,
    "calndrId": ""
  },
  "22mar1012": {
    "label": "Martedì 22 Ottobre (ore 10:00 - 12:00)",
    "position": 14,
    "calndrId": ""
  },
  "22mar1416": {
    "label": "Martedì 22 Ottobre (ore 14:30 - 16:30)",
    "position": 15,
    "calndrId": ""
  },

  /** MAGGIO 24 */

  "13lun1012_24": {
    "label": "Lunedì 13 Maggio (ore 10:00 - 12:00)",
    "position": 10,
    "calndrId": "A8j8ix8GDm"
  },
  "13lun1416_24": {
    "label": "Lunedì 13 Maggio (ore 14:30 - 16:30)",
    "position": 11,
    "calndrId": "ToSf9WPtBd"
  },
  "14mar1012": {
    "label": "Martedì 14 Maggio (ore 10:00 - 12:00)",
    "position": 12,
    "calndrId": "L0tHQPCffn"
  },
  "14mar1416": {
    "label": "Martedì 14 Maggio (ore 14:30 - 16:30)",
    "position": 13,
    "calndrId": "rnxxza74MF"
  },
  "23gio1012": {
    "label": "Giovedì 23 Maggio (ore 10:00 - 12:00)",
    "position": 14,
    "calndrId": "kNYAHnDOm2"
  },
  "23gio1416": {
    "label": "Giovedì 23 Maggio (ore 14:30 - 16:30)",
    "position": 15,
    "calndrId": "RwQtu1wSkB"
  },
  "24ven1012": {
    "label": "Venerdì 24 Maggio (ore 10:00 - 12:00)",
    "position": 16,
    "calndrId": "vccw8t8rw6"
  },
  "24ven1416": {
    "label": "Venerdì 24 Maggio (ore 14:30 - 16:30)",
    "position": 17,
    "calndrId": "6kxNKW258a"
  },

  "10mar1012": {
    "label": "Martedì 10 Ottobre (ore 10:00 - 12:00)",
    "position": 20,
    "calndrId": "lQXhBHjjzK"
  },
  "10mar1416": {
    "label": "Martedì 10 Ottobre (ore 14:30 - 16:30)",
    "position": 21,
    "calndrId": "pgvphiRRVm"
  },
  "11mer1012": {
    "label": "Mercoledì 11 Ottobre (ore 10:00 - 12:00)",
    "position": 22,
    "calndrId": "HOe5bx0HfE"
  },
  "11mer1416": {
    "label": "Mercoledì 11 Ottobre (ore 14:30 - 16:30)",
    "position": 23,
    "calndrId": "phhDQC6v8V"
  },
  "17mar1012": {
    "label": "Martedì 17 Ottobre (ore 10:00 - 12:00)",
    "position": 24,
    "calndrId": "3LPJ2He8sV"
  },
  "17mar1416": {
    "label": "Martedì 17 Ottobre (ore 14:30 - 16:30)",
    "position": 25,
    "calndrId": "yIsYiLh9Up"
  },
  "18mer1012": {
    "label": "Mercoledì 18 Ottobre (ore 10:00 - 12:00)",
    "position": 26,
    "calndrId": "GI39sQo8TF"
  },
  "18mer1416": {
    "label": "Mercoledì 18 Ottobre (ore 14:30 - 16:30)",
    "position": 27,
    "calndrId": "BaNG3i1Sg7"
  }
}
